import { useState } from "react";
import { View } from "ui/atoms/view";
import { Button, ButtonIcon } from "ui/gluestack/button";
import { EditIcon, TrashIcon } from "ui/gluestack/icon";
import QuestionDetailAtom from "../atoms/QuestionDetailAtom";
import { QuestionModel } from "app/services/api/types/forms/models/QuestionModel";
import { useSectionQuestions } from "../context/SectionQuestionsContext";
import QuestionEditModal from "../templates/QuestionEditModal";
import { QuestionOrderAtom } from "../atoms/QuestionOrderAtom";
import { QuestionTypeEnum } from "app/services/api/types/forms/enums/QuestionTypeEnum";

interface Props {
  idx: number;
  question: QuestionModel;
  sectionIndex: number;
}

export function QuestionRowMolecule({ idx, question, sectionIndex }: Props) {
  const { questionFields, removeQuestion, updateQuestion } =
    useSectionQuestions();
  const [isEditOpen, setIsEditOpen] = useState(false);

  return (
    <View className="flex flex-row items-center py-2 gap-4">
      <QuestionOrderAtom questionIndex={idx} sectionIndex={sectionIndex} />

      <View className="flex-1">
        <QuestionDetailAtom question={question} />
      </View>

      <View className="gap-2 flex-row">
        <Button size="xs" variant="outline" onPress={() => setIsEditOpen(true)}>
          <ButtonIcon as={EditIcon} />
        </Button>
        <Button
          size="xs"
          variant="outline"
          action="negative"
          onPress={() => removeQuestion(idx)}
        >
          <ButtonIcon as={TrashIcon} />
        </Button>
      </View>

      <QuestionEditModal
        isVisible={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        initialQuestion={questionFields[idx]}
        onSubmit={(payload) => {
          const existing = questionFields[idx];
          updateQuestion(idx, {
            ...existing,
            content: payload.content ?? existing?.content ?? "",
            type: payload.type ?? existing?.type ?? QuestionTypeEnum.TEXT,
            required: payload.required ?? existing?.required ?? false,
            unit: payload.unit ?? existing?.unit ?? "",
            min_value:
              payload.min_value !== undefined
                ? payload.min_value
                : (existing?.min_value ?? null),
            max_value:
              payload.max_value !== undefined
                ? payload.max_value
                : (existing?.max_value ?? null),
            options:
              payload.options !== undefined
                ? payload.options
                : (existing?.options ?? null),
            instructions:
              payload.instructions !== undefined
                ? payload.instructions
                : (existing?.instructions ?? []),
          });
          setIsEditOpen(false);
        }}
      />
    </View>
  );
}
